import * as Yup from 'yup';
import { isFutureDate } from '../utils/helper';

const AddEditGoalValidation = Yup.object().shape({
  title: Yup.string().trim().required('Please enter goal title.'),
  targetMetric: Yup.string().trim(),
  endDate: Yup.string()
    .required('Please select a due date.')
    .test('is-future', 'Please select a future date.', isFutureDate),
  assignedOwner: Yup.array().min(1, 'Please assign at least one owner.'),
  checklist: Yup.array().of(
    Yup.object().shape({
      text: Yup.string().trim().required('Checklist item cannot be empty.')
    })
  )
});

export default AddEditGoalValidation;
